import Misc from './Misc';

export default Misc;